import PageWrapper from './src/components/layout/pageWrapper';
import React from 'react';

export const onRouteUpdate = () => {
  // console.log('location: ', location);
  if (location.pathname.includes('contact')) {
    let captchaScript = document.getElementById('captchaScript');
    if (captchaScript) {
      captchaScript.remove();
    }
    captchaScript = document.createElement('script');
    captchaScript.id = 'captchaScript';
    captchaScript.async = true;
    captchaScript.defer = true;
    captchaScript.src = 'https://www.google.com/recaptcha/api.js';
    document.body.appendChild(captchaScript);
  }
};

export const wrapPageElement = ({ element, props }) => <PageWrapper {...props}>{element}</PageWrapper>;
